/** Close only when the backdrop layer itself received the pointer event. */
export function shouldCloseImagePreviewOnBackdropPointerDown(
  eventTarget: EventTarget | null,
  backdropElement: EventTarget | null,
): boolean {
  return (
    eventTarget !== null &&
    backdropElement !== null &&
    eventTarget === backdropElement
  );
}

export type InboxImageLoadPhase = "resolving" | "loading" | "loaded" | "error";

export function inboxImageLoadPhase(
  url: string | undefined,
  urlResolving: boolean,
  imageLoaded: boolean,
  failed: boolean,
): InboxImageLoadPhase {
  if (failed) {
    return "error";
  }
  if (!url || urlResolving) {
    return "resolving";
  }
  if (!imageLoaded) {
    return "loading";
  }
  return "loaded";
}
